import * as React from "react";
import PartnerBrand from "../../../../model/partnerBrand/PartnerBrand";
import FleetMileageCaptureSection from "../FleetMileageCaptureSection";
import EvChargingMetersSection from "../../../evCharging/meters/EvChargingMetersSection";

interface Props {
	/**
	 * Saved partner brand. Features exist only once the brand does.
	 */
	partnerBrand: PartnerBrand;
	/**
	 * Indicates if the form holds changes not saved yet.
	 */
	hasUnsavedChanges: boolean;
}

/**
 * Job type features set up per partner: fleet mileage capture and EV charging meters.
 */
const PartnerBrandFeaturesSection = (props: Props) =>
	<>
		<FleetMileageCaptureSection partnerBrand={props.partnerBrand}
									hasUnsavedChanges={props.hasUnsavedChanges}/>
		<EvChargingMetersSection key={props.partnerBrand.id}
								 partnerBrandId={props.partnerBrand.id}
								 partnerBrandName={props.partnerBrand.name}/>
	</>;

export default PartnerBrandFeaturesSection;
